var promo = "https://shopfront-cdn.tekoapis.com/static/5f10c2b8b58ef165.svg";

export { promo as default };
